import { Outlet } from 'react-router-dom';

import { GlobalCatch } from '@/components/common/GlobalCatch';

import './styles.scss';

export const Catch = () => {
  return <GlobalCatch />;
};

export default function App() {
  return <Outlet />;
}
